// 50 soft "thinking" phrases shown while the AI is composing a response.
// Rotates every ~1.5s. The vibe: present, unhurried, human — not "processing".
const PHRASES = [
  "Sitting with what you said…",
  "Reading it twice…",
  "Making space for this…",
  "Letting it land…",
  "Taking this in…",
  "Feeling my way through it…",
  "Slowing down for a second…",
  "Pulling up a chair…",
  "Hearing you…",
  "Choosing the right words…",
  "Getting quiet with this…",
  "Turning it over…",
  "Breathing with it…",
  "Meeting you where you are…",
  "Reaching for the honest thing…",
  "Holding this carefully…",
  "Weighing my words…",
  "Thinking about you…",
  "Getting present…",
  "Making room for what's real…",
  "No rush. I'm here…",
  "Reading it slowly…",
  "Finding my footing…",
  "Listening past the words…",
  "Sitting a moment longer…",
  "Not looking away…",
  "Pausing so I don't rush this…",
  "Letting the noise settle…",
  "Coming close…",
  "Tuning in…",
  "Not moving yet…",
  "Taking a slow breath…",
  "Reaching for something true…",
  "Setting everything else down…",
  "Being with you for a second…",
  "Trying to say this well…",
  "Getting still…",
  "Reading between the lines…",
  "Feeling what you're feeling…",
  "Not rushing you…",
  "Holding space…",
  "Trusting the pause…",
  "Choosing gentleness…",
  "Waiting for the right thought…",
  "Meeting this honestly…",
  "Turning toward you…",
  "Taking my time…",
  "Sitting beside you…",
  "Softening…",
  "With you…",
];

export const pickThinkingPhrase = () => PHRASES[Math.floor(Math.random() * PHRASES.length)];

export default PHRASES;
